'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = require('lodash.clonedeep');

var _lodash2 = _interopRequireDefault(_lodash);

var _redux = require('redux');

var _finance = require('../actions/finance');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_FILTER = {
    date: [],
    type: '',
    keyword: ''
};
var filter = function filter() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_FILTER;
    var action = arguments[1];

    switch (action.type) {
        case _finance.FILTER_FINANCES:
            return Object.assign({}, state, action.filter);
        default:
            return state;
    }
};

var INITIAL_STATE = {
    isFetching: false,
    didInvalidate: false,
    items: [],
    pagination: {}
};
var finances = function finances() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
    var action = arguments[1];

    switch (action.type) {
        case _finance.INVALIDATE_FINANCES:
            return _extends({}, state, {
                didInvalidate: true
            });
        case _finance.REQUEST_FINANCES:
            return _extends({}, state, {
                isFetching: true,
                didInvalidate: false
            });
        case _finance.RECEIVE_FINANCES:
            return _extends({}, state, {
                isFetching: false,
                didInvalidate: false,
                items: action.finances,
                pagination: action.pagination
            });
        case _finance.FAILURE_FINANCES:
            return _extends({}, state, {
                isFetching: false,
                error: action.error
            });
        default:
            return state;
    }
};

var financeReducer = (0, _redux.combineReducers)({
    finances: finances,
    filter: filter
});

exports.default = financeReducer;


//////////////////
// WEBPACK FOOTER
// ./src/js/reducers/finance.js
// module id = 885
// module chunks = 0